import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../models/app-config.model';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private config: AppConfig | null = null;
  private configUrl = 'assets/config/config.json';

  constructor(private http: HttpClient) { }

  /**
   * Load configuration from JSON file
   * This method is called during app initialization via APP_INITIALIZER
   */
  loadConfig(): Observable<AppConfig> {
    return this.http.get<AppConfig>(this.configUrl).pipe(
      tap(config => {
        // Convert string "true"/"false" to boolean if needed
        if (typeof config.production === 'string') {
          config.production = config.production.toLowerCase() === 'true';
        }
        
        // Parse white_listed_Domains if it's a string (JSON array)
        if (typeof config.white_listed_Domains === 'string') {
          try {
            config.white_listed_Domains = JSON.parse(config.white_listed_Domains);
          } catch (e) {
            console.warn('Failed to parse white_listed_Domains, keeping as string');
          }
        }
        
        this.config = config;
        console.log('Configuration loaded:', config);
      })
    );
  }

  /**
   * Get the loaded configuration
   * @throws Error if config hasn't been loaded yet
   */
  getConfig(): AppConfig {
    if (!this.config) {
      throw new Error('Configuration not loaded. Make sure APP_INITIALIZER has completed.');
    }
    return this.config;
  }

  /**
   * Get a specific config value by key
   * @param key The configuration key to retrieve
   */
  get(key: keyof AppConfig): any {
    return this.getConfig()[key];
  }

  /**
   * Check if the app is running in production mode
   */
  isProduction(): boolean {
    const prod = this.getConfig().production;
    return typeof prod === 'boolean' ? prod : prod.toLowerCase() === 'true';
  }
}
